import { put } from 'redux-saga/effects'
import RbacService from '../../services/Rbac'
import RolesService from '../../services/Roles'
import { HTTP_RESPONSE_CODES } from '../../constants/general'
import ACActions from '../actions/AC'

export function * loadRolesCatalog () {
  try {
    const result = yield RolesService.List()
    if (result.status === HTTP_RESPONSE_CODES.SUCCESS) {
      const roles = (result.data || []).map(role => ({
        id: role.id,
        name: role.name,
        assignableInInterface: role.assignableInInterface !== false
      }))
      yield put(ACActions.setRoles(roles))
    }
  } catch (e) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('[AC] Failed to load roles catalog; falling back to static role labels.', e?.message || e)
    }
  }
}

export function * loadUserRbacPermissions (profile) {
  if (!profile?.roleId) {
    yield put(ACActions.clearPermissions())
    return
  }

  try {
    const result = yield RbacService.GetRolePermissions(profile.roleId)
    if (result.status === HTTP_RESPONSE_CODES.SUCCESS) {
      yield put(ACActions.setPermissions(profile.roleId, result.data || []))
      return
    }
  } catch (e) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('[AC] Failed to load RBAC permissions; role-based checks still apply.', e?.message || e)
    }
  }

  yield put(ACActions.setPermissions(profile.roleId, []))
}
